import { render } from "./App.vue?vue&type=template&id=4da42f1b"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4da42f1b&lang=scss"

import exportComponent from "G:\\Project\\vue_demo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__